export default "__VITE_ASSET__CWrpLLyB__"